const INSURANCE_PERSON_STATUS = {
  CALCULATION: 'CALCULATION',
  PAYMENT_PENDING: 'PAYMENT_PENDING',
  ACTIVE: 'ACTIVE',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED'
};

Object.freeze(INSURANCE_PERSON_STATUS);

export { INSURANCE_PERSON_STATUS };


// WEBPACK FOOTER //
// ./client/app/shared/enum/InsurancePersonStatusEnum.js